import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0% {
    transform: scale(0.9);
    opacity: 0.6;
  }

  50% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    transform: scale(0.9);
    opacity: 0.6;
  }
`;

const Wrapper = styled.div`
  display: grid;
  place-items: center;
  min-height: ${({ $compact }) => ($compact ? "240px" : "70vh")};
  gap: 1rem;
  text-align: center;
`;

const Dot = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.red};
  box-shadow: 0 0 24px rgba(229, 9, 20, 0.45);
  animation: ${pulse} 1.1s ease-in-out infinite;
`;

const Label = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textMuted};
`;

function PageLoader({ label = "Preparando a experiencia...", compact = false }) {
  return (
    <Wrapper $compact={compact}>
      <Dot aria-hidden />
      <Label>{label}</Label>
    </Wrapper>
  );
}

export default PageLoader;
